import { registerBlockType } from '@wordpress/blocks';

import './editor.css';
import './style.css';

import metadata from './block.json';
import Edit from './edit';
import save from './save';
import deprecated from './deprecated';

registerBlockType( metadata.name, {
  edit: Edit,
  save,
  deprecated
});
